import React, { useState, useEffect } from 'react';
import CustomTable from '../../../../customComponents/CustomTable';
import downloadIcon from './../../../../../Assets/icons/download.svg';
import DownloadSVG from './../../../../../Assets/icons/DownloadIconMIS.svg';
import './index.scss';
import editIcon from './../../../../../Assets/icons/Un-Checkbox.svg';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../services/api/API';
import ROUTES_NAVIGATION from '../../../../../routes/routes';
import Loader from '../../../../customComponents/CustomLoader';
import SearchInput from '../../../../customComponents/CustomSearch/SearchInput';
import { FiDownload } from 'react-icons/fi';
import ListLogisticsFilters from '../../../Logistics/LogisticsFilter';
import { showAlert } from '../../../../customComponents/CustomSweetAlert/ShowAlert';
import DynamicForm from '../../../../customformComponent/customForm/DynamicForm';
import Swal from 'sweetalert2';

const VariantList = () => {
  const [variantData, setVariantData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);
  const [totalActive, setTotalActive] = useState(0);
  const [totalInactive, setTotalInactive] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [colorOptions, setColorOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [exportModal, setExportModal] = useState(false);
  const [formData, setFormData] = useState({});

  const [stateDdl, setStateDdl] = useState([]);

  const [filterFormData, setFilterFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});

  const navigate = useNavigate();
  const token = localStorage.getItem('authToken');

  const handleExportModalOpen = () => {
    setExportModal(true);
    setFormData({});
  };

  const handleExportModalClose = () => {
    setExportModal(false);
    setFormData({});
  };

  useEffect(() => {
    fetchModelOptions();
  }, []);

  const fetchModelOptions = async (makeId) => {
    try {
      const payload = {
        orderBy: 'model_id desc',
        page: 0,
        pageSize: 100,
      };

      const response = await axiosInstance.post('/model/ddlmodel', payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      const options = response.data.data.data.map((model) => ({
        label: model.NAME,
        value: model.ID,
      }));

      setModelOptions(options);
    } catch (error) {
      console.error('Error fetching model options:', error);
    }
  };

  useEffect(() => {
    fetchColorOptions();
  }, []);

  const fetchColorOptions = async () => {
    try {
      const payload = {};
      // if (userType === "superadmin") {
      //   payload.business_partner_id = formData.business_partner_id;
      // } else {
      //   payload.business_partner_id = businessPartnerId;
      // }

      const response = await axiosInstance.post('/color/ddlcolor', payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      const options = response.data.data.data.map((color) => ({
        label: color.NAME,
        value: color.ID,
      }));

      setColorOptions(options);
    } catch (error) {
      console.error('Error fetching color options:', error);
    }
  };

  useEffect(() => {
    stateDropdown();
  }, []);

  const stateDropdown = async () => {
    try {
      const response = await axiosInstance.get('/pincodestatecity/stateList', {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response.data.data.map((user) => ({
        value: user.ID,
        label: user.NAME,
      }));

      setStateDdl(data);
    } catch (error) {
      console.log(error);
    }
  };

  const handlePageChange = (newPage) => {
    console.log(newPage, 'newPage');
    setCurrentPage(newPage);
    fetchVariantList(newPage);
  };

  const fetchVariantList = async (page = 0, pageSize = 10) => {
    const allfilteredData = filters;
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        '/variant/list',
        {
          orderBy: 'variant_id desc',
          page,
          pageSize,
          searchText: searchTerm,
          modelId: allfilteredData?.modelId ? allfilteredData?.modelId : '',
          stateId: allfilteredData?.stateId ? allfilteredData?.stateId : '',
          colorId: allfilteredData?.colorId ? allfilteredData?.colorId : '',
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        'Sr No.': index + 1,
      }));

      const totalRecordsData = response?.data?.data?.totalRecords;

      const totalCount = response?.data?.data?.total;
      const totalAct = response?.data?.data?.total_active;
      const totalInac = response?.data?.data?.total_inactive;

      setTotalData(totalCount);
      setTotalActive(totalAct);
      setTotalInactive(totalInac);

      console.log(totalRecordsData, 'RECORDS');
      setTotalRecords(totalRecordsData);

      setVariantData(formattedData);
      // console.log(
      //   response?.data?.data?.countdata?.total,
      //   'data?.data?.countdata?.total',
      // );
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error('Error fetching variant list:', error);
    } finally {
      setLoading(false);
    }
  };

  const downloadExcel = async () => {
    const allfilteredData = filters;
    const payload = {
      // dealerId: allfilteredData?.dealerId ? allfilteredData?.dealerId : dealerId,
      // state_id: "",
      // services_by: "",
      // servicesValue_Id: "",
      poStatus: 0,
      fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : '',
      toDate: allfilteredData?.fromDate ? allfilteredData?.toDate : '',
      searchText: searchTerm,
      modelId: allfilteredData?.modelId ? allfilteredData?.modelId : '',
      stateId: allfilteredData?.stateId ? allfilteredData?.stateId : '',
      colorId: allfilteredData?.colorId ? allfilteredData?.colorId : '',
      orderBy: '',
    };

    try {
      const response = await axiosInstance.post(
        '/variant/variant-report-excel',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          responseType: 'blob',
        },
      );
      const blob = new Blob([response.data], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'variant.csv';
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading Excel file:', error);
    }
  };
  const VARIANT_TABLE_HEADERS = [
    // "Product Name",
    // "SubProduct Name",
    // "Make Name",
    'Variant Name',
    'Model Name',
    'Color',
    // "Fuel Type",
    'Dealer Price ₹',
    'Recommended Selling Price ₹',
    'State Name',
    // "Description",
    'Status',
    'Action',
  ];

  const variantKeyMapping = {
    'Product Name': 'product_name',
    'SubProduct Name': 'subproduct_name',
    'Make Name': 'make_name',
    'Model Name': 'model_name',
    'Fuel Type': 'fuel_type_name',
    Color: 'color_name',
    'Recommended Selling Price ₹': 'exshowroom_price',
    'Dealer Price ₹': 'dealer_price',
    'State Name': 'state_name',
    'Variant Name': 'battryName',
    Description: 'variant_desc',
    Status: 'status',
    Action: [{ type: 'edit', icon: editIcon, label: 'Edit' }],
  };

  const handleEdit = (rowData) => {
    console.log('rowdata>', rowData);
    navigate(`${ROUTES_NAVIGATION.EDITVARIANT}`, { state: { data: rowData } });
  };

  useEffect(() => {
    if (searchTerm === '') {
      fetchVariantList();
    }
  }, [searchTerm]);

  const PhysicalStockTakingInputs = [
    {
      // name: "variant",
      name: 'modelId',
      label: 'Model',
      placeholder: '',
      type: 'dropdown',
      options: modelOptions,
      // required: true,
      gridClass: 'col-lg-3',
      // validation: { required: true }
    },
    {
      name: 'colorId',
      label: 'Vehicle Color',
      type: 'dropdown',
      options: colorOptions,
      validation: {
        // required: true,
      },
      // required: true,
      gridClass: 'col-lg-3',
    },
    {
      name: 'stateId',
      label: 'State',
      type: 'dropdown',
      options: stateDdl,
      validation: {
        // required: true,
      },
      // required: true,
      gridClass: 'col-lg-3',
    },
  ];

  const handleSearch = () => {
    // Update the filters state with the current form data
    setFilters({
      stateId: filterFormData.stateId || 0,
      colorId: filterFormData.colorId || null,
      modelId: filterFormData.modelId || null,
    });
  };

  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    fetchVariantList();
  };

  useEffect(() => {
    fetchVariantList(0, 10);
  }, [filters]);

  const UploadInputs = [
    {
      name: 'uploadDocument',
      label: ' ',
      type: 'uploadCsvOrderManagement',
      required: true,
      gridClass: 'col-lg-6',
      //validation:{required:true}
    },
  ];

  const handleFormSubmit = async (formData) => {
    const result = await Swal.fire({
      title: 'Confirmation',
      text: 'Are you sure you want to this record?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        try {
          const formDataToSend = new FormData();
          formDataToSend.append('importFileUpload', formData.uploadDocument);
          // formDataToSend.append("loginUserId", loginUserId);

          const response = await axiosInstance.post(
            `variant/importbulk`,
            formDataToSend,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${token}`,
              },
            },
          );

          if (response.status === 200) {
            await showAlert({
              title: 'Success',
              text: 'File Uploaded successfully.',
              icon: 'success',
              confirmButtonText: 'OK',
            });
            setExportModal(false);
            fetchVariantList();
          }

          // if (errors.length > 0) {
          //   setExportModal(false); // Close the custom modal

          //   // Show SweetAlert modal with failed record info
          //   await showAlert({
          //     title: "Upload Unsuccessful",
          //     text: `File uploaded with ${success.length} successful rows and ${errors.length} failed rows.`,
          //     icon: "warning",
          //     confirmButtonText: "Export Failed Rows",
          //     showCancelButton: true,
          //     cancelButtonText: "Close"
          //   }).then((result) => {
          //     if (result.isConfirmed) {
          //       // downloadFailedRowsCSV(formData.uploadDocument, errors); // Call your CSV download function
          //     }
          //   });

          // } else {
          //   // fetchActionTaken();
          //   setExportModal(false);
          // }
        } catch (error) {
          // const errorMessage =
          // await showAlert({
          //   title: "Error",
          //   text: "An error occurred while uploading the file.",
          //   icon: "error"
          // });
          console.error(
            'Error submitting uploadform:',
            error?.response?.data?.data,
          );
          const errorMessage = error?.response?.data?.data;
          await showAlert({
            title: 'Error',
            text: errorMessage || 'An error occurred while uploading the file.',
            icon: 'error',
          });
        }
      },
    });

    if (!result.isConfirmed) {
      // Optional: handle if user cancels the confirmation
    }
  };

  const handleExport = async () => {
    // console.log(item.po_details_id, "itemData>>>>>");

    try {
      const response = await axiosInstance.get(`/variant/bulkUploadSample`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
      });
      console.log(response, 'resposne');

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement('a');
      link.href = url;

      link.setAttribute('download', 'sample.csv');

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
    } catch (error) {
      console.error('Error accepting order:', error);
      alert('Failed to accept order');
    }
  };

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="OnboardManagamentContainer">
            <div className="OnboardManagamentbuttonContainer">
              <h5>Variant Management</h5>
            </div>
            <div className="totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2">
              <div
                className="totalvaltopleftdataContainerues"
                style={{ borderRight: '1px solid lightgrey' }}
              >
                <h5 className="listTopDataValueText">{totalData} </h5>
                <h6>All Variant</h6>
              </div>
              <div
                className="topleftdataContainer"
                style={{ borderRight: '1px solid lightgrey' }}
              >
                <h5 className="listTopDataValueText">{totalActive} </h5>
                <h6>Active Variant</h6>
              </div>
              <div className="topleftdataContainer">
                <h5 className="listTopDataValueText">{totalInactive} </h5>
                <h6>Inactive Variant</h6>
              </div>
              <button
                className="addcustomerbutton"
                onClick={() =>
                  navigate('/admin/manage-product/variant/add-variant')
                }
              >
                Add Variant
              </button>
            </div>
          </div>
          <div className="tableWrapper">
            <div className="admin-list-container">
              <div className="listsearchContainer">
                <h5 style={{ paddingTop: '2rem' }}>Variant List</h5>
                <div style={{ paddingTop: '2rem' }}>
                  <SearchInput
                    placeholder="Search Variant"
                    onSearch={fetchVariantList}
                    searchTerm={searchTerm}
                    setSearchTerm={setSearchTerm}
                  />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div
                    onClick={downloadExcel}
                    className="flte-btnnn"
                    style={{
                      borderRadius: '38px',
                      cursor: 'pointer',
                      marginTop: '2rem',
                    }}
                  >
                    Export
                    <span>
                      {/* <img
                                    onClick={downloadExcel}
                                    src={DownloadSVG}
                                    alt="downloadSvg"
                                    className="downloadexcel-misreportsales"
                                    style={{
                                      // paddingTop: "9rem",
                                      // paddingRight: "1rem",
                                      
                                      cursor: "pointer",
                                      height:"24px"
                                    }}
                                  /> */}
                      <FiDownload
                        className="downloadexcel-misreportsales"
                        style={{ cursor: 'pointer' }}
                        size={22}
                      />
                    </span>
                  </div>
                  {/* <div
                    className="flte-btnnn"
                    onClick={handleExportModalOpen}
                    style={{
                      borderRadius: "38px",
                      cursor: "pointer",
                      marginTop: "2rem",
                    }}
                  >
                    Import
                    <span></span>
                  </div> */}
                </div>
              </div>
            </div>
            <ListLogisticsFilters
              formConfig={PhysicalStockTakingInputs}
              formData={filterFormData}
              setFormData={setFilterFormData}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
              handleSearch={handleSearch}
              handleClear={clearFilter}
            />
            <CustomTable
              data={variantData}
              headers={VARIANT_TABLE_HEADERS}
              keyMapping={variantKeyMapping}
              itemsPerPage={10}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              onEdit={handleEdit}
              totalRecords={totalRecords}
            />
          </div>
        </>
      )}

      {exportModal && (
        <div className="customModalOverlay">
          <div className="custom-modal">
            <div className="custom-modal-header">
              <h6 style={{ fontSize: '18px' }}> Upload </h6>
              <button className="close-button" onClick={handleExportModalClose}>
                ×
              </button>
            </div>
            <div className="custom-modal-body">
              <div>
                {/* <label style={{ display: "block", marginBottom: "8px", fontWeight: "bold" }}>
                          Export Date 
                        </label> */}
                <div>
                  <div className="input-group">
                    {/* <DatePicker
                            ref={(ref) => (datePickerRefs.current["expectedDate"] = ref)}
                            placeholderText="DD/MM/YYYY"
                            selected={expectedDate ? new Date(expectedDate.split("/").reverse().join("-")) : null}
                            onChange={(date) => handleChange("expectedDate", date)}
                            dateFormat="dd/MM/yyyy"
                            className="form-control"
                             popperPlacement="bottom-start"
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            
                          /> */}
                    {/* <span
                            className="input-group-text"
                            onClick={() => openDatePicker("expectedDate")}
                            style={{ cursor: "pointer" }}
                          >
                            <FaCalendarAlt />
                          </span> */}
                  </div>
                </div>
              </div>

              <label
                htmlFor="expectedDate"
                style={{
                  display: 'block',
                  marginBottom: '8px',
                  fontWeight: 'bold',
                  paddingTop: '20px',
                }}
              >
                Download
              </label>

              <div
                style={{ borderRadius: '30px', width: '250px' }}
                className="downloadiconwrapperr"
                onClick={handleExport}
              >
                <a
                  style={{ fontSize: '15px', cursor: 'pointer' }}
                  className="downloadHeading"
                >
                  Download
                </a>
                <img
                  src={downloadIcon}
                  alt="download"
                  className="downloadImg"
                />
              </div>

              {/* <div
                style={{ borderRadius: "30px", width: "250px" }}
                className="downloadiconwrapperr"
              >
                <img
                  src={downloadIcon}
                  alt="download"
                  className="downloadImg"
                />
              </div> */}

              <div>
                <DynamicForm
                  formConfig={UploadInputs}
                  formData={formData}
                  setFormData={setFormData}
                  onSubmit={handleFormSubmit}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors}
                />
              </div>
            </div>
            <div className="custom-modal-footer">
              <button
                className="btn btn-primary"
                style={{
                  background: '#7BD755',
                  color: 'white',
                  border: 'none',
                  borderRadius: '20px',
                  padding: ' 10px 28px',
                }}
                onClick={() => handleFormSubmit(formData)}
              >
                Submit
              </button>
              <button
                className="btn btn-primary"
                style={{
                  background: 'white',
                  color: '#7BD755',
                  border: '1px solid #7BD755',
                  borderRadius: '20px',
                  padding: ' 10px 28px',
                }}
                onClick={handleExportModalClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VariantList;
